import { useMemo } from 'react';
import { mergeSizes } from '../../utils/spacing/mergeSizes';
/**
 * Custom hook to extract SpacingProps from a given set of props and transforms
 * them to an CSS shorthand notation array with four entries
 *
 * @param {Object} props List of props
 * @returns {SpacingShorthandList}
 */

export function useSpacing(_ref) {
  var shorthand = _ref.spacing,
      stackStart = _ref.spaceStackStart,
      inlineEnd = _ref.spaceInlineEnd,
      stackEnd = _ref.spaceStackEnd,
      inlineStart = _ref.spaceInlineStart;
  return useMemo(function () {
    return mergeSizes(shorthand, [stackStart, inlineEnd, stackEnd, inlineStart]);
  }, [shorthand, stackStart, inlineEnd, stackEnd, inlineStart]);
}